/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectVisitGeocodedDtoBase
 * auto generated base class for the model ProjectVisitGeocodedDtoModel.
 *
 * Visit geocoded event for project level
 */
export const ProjectVisitGeocodedDtoModelBase = ModelBase
  .named('ProjectVisitGeocodedDto')
  .props({
    __typename: types.optional(types.literal("ProjectVisitGeocodedDto"), "ProjectVisitGeocodedDto"),
    remaining: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectVisitGeocodedDtoModelSelector extends QueryBuilder {
  get remaining() { return this.__attr(`remaining`) }
}
export function selectFromProjectVisitGeocodedDto() {
  return new ProjectVisitGeocodedDtoModelSelector()
}

export const projectVisitGeocodedDtoModelPrimitives = selectFromProjectVisitGeocodedDto().remaining
